export default {
  isEnterprise: true,
  portOptions: [],
  colorOptions: [],
  displaySettings: [],
  selectedPort: {},
  selectedMenuItem: "portSelect",
  rankOptions: [],
  storedMasterSearchCondition: {},
  enterpriseMenuItems: [
    {
      name: "港湾選択",
      path: "addon-port-master-port-select",
    },
    {
      name: "代理店管理",
      path: "addon-port-master-enterprise-agency-master",
    },
  ],
  enterprisePortMenuItems: [
    {
      name: "入出港予定表",
      path: "addon-port-master-destination-order-list",
    },
    {
      name: "船舶管理",
      path: "addon-port-master-vessel-master",
    },
    {
      name: "タグ管理",
      path: "addon-port-master-tag-master",
    },
    {
      name: "車両管理",
      path: "addon-port-master-vehicle-master",
    },
    {
      name: "綱ボート管理",
      path: "addon-port-master-rope-picking-boat-master",
    },
    {
      name: "バース管理",
      path: "addon-port-master-berth-master",
    },
    {
      name: "班長管理",
      path: "addon-port-master-team-leader-master",
    },
    {
      name: "水先案内人管理",
      path: "addon-port-master-pilot-master",
    },
    {
      name: "タグボート管理",
      path: "addon-port-master-tug-boat-master",
    },
    /* 次のフェーズまでコメントアウト
    {
      name: "代理店管理",
      path: "addon-port-master-agency-master",
    },
    */
  ],
}